import React from 'react';
import PropTypes from 'prop-types';
import { Field, ErrorMessage, getIn } from 'formik';
import InputErrorMessage from './InputErrorMessage';

import Check from '../../assets/icons/check.svg';
import s from './CheckboxInput.module.scss';

function CheckboxInput(props) {
  const { field, form, labelContent, required, disabled } = props;
  const { name, value, onChange } = field;

  let isError = false;
  const touched = getIn(form.touched, name);
  const errors = getIn(form.errors, name);
  if (touched && errors) {
    isError = true;
  }

  const errorMsgClassName = `${name}-errorMsg`;

  return (
    <div className={s.checkboxWrapper}>
      <label htmlFor={name}>
        <Field
          type="checkbox"
          name={name}
          checked={value || false}
          id={name}
          onChange={onChange}
          required={required}
          disabled={disabled}
          aria-invalid={isError}
          aria-describedby={isError ? errorMsgClassName : null}
        />
        <div className={s.checkmark}>{value && <img src={Check} alt="" />}</div>
        <div>{labelContent}</div>
      </label>
      <div id={errorMsgClassName}>
        <ErrorMessage name={name} component={InputErrorMessage} />
      </div>
    </div>
  );
}

CheckboxInput.defaultProps = {
  disabled: false,
  required: false,
};

CheckboxInput.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.bool,
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    touched: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    errors: PropTypes.object,
  }).isRequired,
  labelContent: PropTypes.node.isRequired,
  required: PropTypes.bool,
  /** disable field */
  disabled: PropTypes.bool,
};

export default CheckboxInput;
